import Vue from "vue";

/**
 * 操作日誌導出：全站單例狀態。
 * - active：任務進行中（與原 oplogExportLock 一致，防並發）
 * - preparing：首包/上限校驗階段
 * - toastVisible：右下角「進行中」Toast（可關閉）
 */
export const oplogExportHud = Vue.observable({
  active: false,
  preparing: false,
  toastVisible: false,
  /** 導出目標供應商展示名（與日誌頁頭部一致），供 Toast 標題行右側顯示 */
  exportContextLabel: "",
  /** 非空時覆蓋 EmpDownloadHudHost 內進度文案（如銷售線索導出） */
  progressTitle: "",
  progressSubtitle: "",
});

export function oplogExportHudStartJob(exportContextLabel = "", progressMessages = null) {
  oplogExportHud.active = true;
  oplogExportHud.preparing = true;
  oplogExportHud.toastVisible = true;
  oplogExportHud.exportContextLabel =
    typeof exportContextLabel === "string" ? exportContextLabel.trim() : "";
  const pm = progressMessages && typeof progressMessages === "object" ? progressMessages : null;
  oplogExportHud.progressTitle = pm && typeof pm.title === "string" ? pm.title : "";
  oplogExportHud.progressSubtitle = pm && typeof pm.subtitle === "string" ? pm.subtitle : "";
}

export function oplogExportHudEndPreparing() {
  oplogExportHud.preparing = false;
}

/** 僅隱藏 Toast（成功前用戶關閉、或衝突/上限等路徑需收起條） */
export function oplogExportHudHideToast() {
  oplogExportHud.toastVisible = false;
}

/** 任務結束（finally）：清空鎖與 HUD */
export function oplogExportHudFinishJob() {
  oplogExportHud.active = false;
  oplogExportHud.preparing = false;
  oplogExportHud.toastVisible = false;
  oplogExportHud.exportContextLabel = "";
  oplogExportHud.progressTitle = "";
  oplogExportHud.progressSubtitle = "";
}

/** 與原「點 X 關閉」一致：關閉條 */
export function oplogExportHudDismissToast() {
  oplogExportHud.toastVisible = false;
  /* 任務仍進行中時保留 exportContextLabel，以便再次展開仍顯示公司名 */
}
